import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import store from './store'
import utils from '@/utils/utils.js'
Vue.config.productionTip = false
const app = new Vue({
	store,
	router,
	render: h => h(App)
})
Vue.prototype.$oss = "https://oss.mcn-open.com/"
Vue.use(utils, app)
app.$mount('#app')
